// src/settings/SettingsTabMenu.jsx
import React from 'react';
import styles from './Settings.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import { redirectToLogin } from '../utils/authRedirect';

const apiUrl = process.env.REACT_APP_API_URL;

const TABS = [
  { key: 'profil', label: 'Editare profil' },
  { key: 'preferinte', label: 'Preferinte' },
  { key: 'resetare-progres', label: 'Resetare progres' },
];

const SettingsTabMenu = ({ activeTab, onTabClick }) => {
  const handleLogout = async () => {
    try {
      await fetch(`${apiUrl}/logout`, {
        method: 'POST',
        credentials: 'include',
      });

      redirectToLogin();
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <>
      <div className={styles.tabMenuCard}>
        {TABS.map(tab => (
          <button
            key={tab.key}
            className={
              activeTab === tab.key
                ? styles.tabActive
                : styles.tab
            }
            onClick={() => onTabClick(tab.key)}
            style={{ width: '95%' }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div
        style={{
          marginTop: 32,
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <button
          className={styles.logoutButton}
          style={{
            marginTop: 0,
            justifyContent: 'center',
          }}
          onClick={handleLogout}
        >
          <FontAwesomeIcon
            icon={faRightFromBracket}
            style={{ fontSize: '1.3em' }}
          />

          Deconectare
        </button>
      </div>
    </>
  );
};

export default SettingsTabMenu;